import { CoveragePlanCard } from '@cms-max/medicare-api-sdk'
import { MyDialog } from 'components/MyDialog'
import { usePlansQuery } from 'queries/plans'
import { useCallback, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { setActiveTrap } from 'redux/reducers/modal'
import { useFilterPlans } from '../CurrentPlans/useFilterPlans'
import PlanHistoryCard from '../PlanHistoryCard/PlanHistoryCard'
import PlanHistoryEmptyAlert from './PlanHistoryEmptyAlert'
import PlanHistoryErrorAlert from './PlanHistoryErrorAlert'

import classes from './PlanHistoryModal.module.scss'

function useOrderedPastPlans (plans: CoveragePlanCard[]) {
  return useMemo(() => {
    return plans.sort((a, b) => {
      const startDateA = new Date(a.enrollment_effective_date)
      const startDateB = new Date(b.enrollment_effective_date)

      return startDateA > startDateB ? -1 : 1
    })
  }, [plans])
}

export function PlanHistoryModal () {
  const { t } = useTranslation('accountHome', { keyPrefix: 'planHistory' })

  const history = useHistory()
  const handleClose = useCallback(() => history.replace('/home'), [history])

  // TODO - remove this once we can switch over to native <dialog>
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setActiveTrap({ isActiveTrap: true }))

    return () => {
      dispatch(setActiveTrap({ isActiveTrap: false }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { data: planData, isError } = usePlansQuery()
  const { past } = useFilterPlans(planData?.plans)

  const orderedPlans = useOrderedPastPlans(past)

  return (
    <MyDialog
      containerId="medicare-my-plans-history"
      heading={t('heading')}
      onClose={handleClose}
      closeButtonAriaLabel={t('Close')}
      width="full"
      className={classes.dialog}
    >
      <div className="">
        {orderedPlans.length > 0 && (
          <>
            <div>{t('description')}</div>

            <div className="ds-u-display--flex ds-u-flex-direction--column my-u-gap--8 ds-u-margin-top--3">
              {past?.map((plan) => (
                <PlanHistoryCard
                  title={plan.title}
                  name={plan.name}
                  effectiveDate={plan.enrollment_effective_date}
                  disenrollmentDate={plan.disenrollment_date}
                />
              ))}
            </div>
          </>
        )}

        {!isError && past.length === 0 && <PlanHistoryEmptyAlert />}

        {isError && <PlanHistoryErrorAlert />}
      </div>
    </MyDialog>
  )
}
